'use strict';

import dispatcher from '../dispatcher';
import store from './form.store';
import {http} from '../utils';
import reCaptcha from './reCaptcha';


let idName = 'form-id-';
let idNum = 0;



function _getId() {
  idNum++;
  return idName + idNum;
}


function _check(field, once) {
  let successValidation = true;

  if (field.hasAttribute('is')) {
    successValidation = once ? !field.onceError : !field.error;
  } else {
    if (field.type === 'checkbox' && !field.checked) {
      field.parentNode.classList.add('error');
      successValidation = false;
    } else if (field.type === 'select-one' && field.selectedIndex === 0) {
      field.parentNode.classList.add('error');
      successValidation = false;
    } else if (!field.value || field.value === '') {
      field.parentNode.classList.add('error');
      successValidation = false;
    }

    if (!successValidation) {
      if (once) {
        setTimeout(() => field.classList.remove('error'), once);
      }

      field.addEventListener('input', () => field.classList.remove('error'), false);
      field.addEventListener('change', () => field.classList.remove('error'), false);
    }
  }

  return successValidation;
}


class Form extends HTMLFormElement {
  constructor(self) {
    self = super(self);
    self.init.call(self);
  }

  init() {
    this._status = false;

    this.subscribe = e => this._subscribe(e);
    this.noAjaxSubmit = e => this._noAjaxSubmit(e);
    this.ajaxSubmit = e => this._ajaxSubmit(e);
  }

  connectedCallback() {
    this._id = this.dataset.id || this.id || _getId();
    this._action = this.action;
    this._once = +this.dataset.once;
    this._noAjax = this.dataset.ajax === 'false';
    this._requiredFields = Array.from(this.querySelectorAll('[data-required]'));
    this._responseInner = this.querySelector('.form-response');

    reCaptcha.subscribe(() => {
      const fieldset = this.querySelector('.formDisabled');
      if (fieldset) fieldset.removeAttribute('disabled');
    });

    if (this._noAjax) {
      this.addEventListener('submit', this.noAjaxSubmit);
    } else {
      this.addEventListener('submit', this.ajaxSubmit);
    }

    dispatcher.dispatch({
      type: 'form-add',
      _module: 'form.component',
      id: this._id
    });

    this._countClap = [];
    setTimeout(() => {
      this._requiredFields.forEach((field, index) => {
        this._countClap[index] = field.error;

        field.addListener((value, error) => {
          this._countClap[index] = error;
          this._clap()
        });
      });
      this._clap();
    });

    this._subscribe(store.getData());
    store.eventEmitter.subscribe(this.subscribe);
  }

  disconnectedCallback() {
    store.eventEmitter.unsubscribe(this.subscribe);

    dispatcher.dispatch({
      type: 'form-remove',
      _module: 'form.component',
      id: this._id
    });
  }

  _subscribe(e) {
    if (!e.items.hasOwnProperty(this._id) || e.items[this._id].status === this._status) return;

    this._status = e.items[this._id].status;
    this.classList.remove('waiting', 'sending', 'submitted');
    this.classList.add(this._status);
  }

  _clap() {
    let c = 0;
    this._countClap.forEach(ci => !ci && c++);

    const coeff = c / this._countClap.length;

    if (coeff >= 1) {
      this.classList.add('validated');
    } else {
      this.classList.remove('validated');
    }

    this.style.setProperty('--clap', `${coeff * 100}%`);
  }

  _validate() {
    let result = true;
    for (let i = 0; this._requiredFields.length > i; i++) {
      if (!_check(this._requiredFields[i], this._once)) result = false;
    }

    return result;
  }

  _noAjaxSubmit(e) {
    if (!this._validate() || this._status !== 'waiting') {
      e.preventDefault();
      return false
    }
  }
  _onSuccess(e, data) {
    if (this._responseInner) {
      this._responseInner.innerHTML = e.response.text;
    }

    dispatcher.dispatch({
      type: 'show-response',
      _module: 'form.component',
      status: e.status,
      title: e.response.title,
      text: e.response.text
    }, {
      type: 'form-submit',
      _module: 'form.component',
      id: this._id,
      data: data
    });

    this.reset();

    setTimeout(() => {
      this._countClap.map(() => false);
      this._clap();

      dispatcher.dispatch({
        type: 'form-reset',
        _module: 'form.component',
        id: self._id,
        data: false
      });
    }, 300);
  }
  _onError(e) {
    if (this._responseInner) {
      this._responseInner.innerHTML = e.response.text;
    }

    dispatcher.dispatch({
      type: 'show-response',
      _module: 'form.component',
      status: 'error',
      title: e.response.title,
      text: e.response.text
    }, {
      type: 'form-error',
      _module: 'form.component',
      id: this._id
    });
  }
  _ajaxSubmit(e) {
    e.preventDefault();

    grecaptcha.execute(reCaptcha.key, {action: 'submit'}).then((token) => {
      if (!this._validate() || this._status !== 'waiting') return;

      const data = new FormData(this);

      data.append('recaptcha_token', token);

      dispatcher.dispatch({
        type: 'form-send',
        _module: 'form.component',
        id: this._id,
        data: data
      });

      http({action: this._action, data: data})
        .then(e => this._onSuccess(e, data))
        .catch(e => this._onError(e));
    });
  }
}

window.customElements.define('view-form', Form, {extends: 'form'});